import { parsePhoneNumberFromString } from 'libphonenumber-js';

import { PHONE_CODES } from '../const/phone-codes';

const getPhoneFromCodeAndNumber = ({ code, number }: { code: string; number: string }) =>
  code + number;

const getCodeAndNumberFromPhone = (phone: string) => {
  const code = PHONE_CODES.find(item => phone.startsWith(item.value))?.value || '+';
  const number = phone.replace(code, '');

  return { code, number };
};

/**
 * The E.164 form of a valid phone number, undefined for an invalid one. Also
 * swallows a habitual national leading zero: '+44' + '07…' becomes '+447…'.
 * For a number that is about to be given a paid SMS for the first time.
 */
const normalizePhoneNumber = (phone: string): string | undefined => {
  const parsed = parsePhoneNumberFromString(phone);

  return parsed?.isValid() ? parsed.number : undefined;
};

/**
 * The same E.164 form, but the number only has to be of a plausible length for
 * its country. Sign-in takes numbers that already have an account, including
 * ones outside the ranges a country actually assigns: nothing checked them when
 * those accounts were made, and refusing them now locks their owners out.
 */
const normalizePossiblePhoneNumber = (phone: string): string | undefined => {
  const parsed = parsePhoneNumberFromString(phone);

  return parsed?.isPossible() ? parsed.number : undefined;
};

export {
  getPhoneFromCodeAndNumber,
  getCodeAndNumberFromPhone,
  normalizePhoneNumber,
  normalizePossiblePhoneNumber,
};
